import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';





 const routes: Routes = [
  {
    path: '',
    redirectTo: 'register',
    pathMatch: 'full'
  },
  {
    path: 'register',
    loadChildren: () => import('./modules/registration/registration.module').then(m => m.RegistrationModule)
  }
];
  
  @NgModule({
    imports: [
      RouterModule.forRoot(
        routes, { 
          onSameUrlNavigation: 'reload',
          scrollPositionRestoration: 'enabled' 
        })
    ],
    exports: [RouterModule],
    providers: [   
          ]
  })
  export class AppRoutingModule {}